import React from 'react';
import { SpinnerScreen } from './spinnerScreen';
import { getCustomString } from '@bb-remark/web-utils';

export const MAINTENANCE_STATUS = {
  PENDING : 'pending',
  TRUE: 'true'
};

export const MaintenanceScreen = () => {
  return (
    <SpinnerScreen title={getCustomString('maintenanceScreenTitle')} description={getCustomString('maintenanceScreenDesc')} error={true} className="js-maintenance-mode" />
  );
};